import _Map from "@babel/runtime-corejs2/core-js/map";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { objectToQueryString, HTTPError, booleanToString } from './libs';
export var CasClient = /*#__PURE__*/function () {
  function CasClient(_ref) {
    var casUrl = _ref.casUrl,
        serviceUrl = _ref.serviceUrl,
        language = _ref.language,
        enableFlagHandling = _ref.enableFlagHandling,
        enableRecaptcha = _ref.enableRecaptcha;

    _classCallCheck(this, CasClient);

    _defineProperty(this, "casUrl", void 0);

    _defineProperty(this, "serviceUrl", void 0);

    _defineProperty(this, "language", void 0);

    _defineProperty(this, "enableFlagHandling", void 0);

    _defineProperty(this, "enableRecaptcha", void 0);

    _defineProperty(this, "executionKey", void 0);

    _defineProperty(this, "loginTicket", void 0);

    _defineProperty(this, "eventId", void 0);

    if (!casUrl || !serviceUrl) {
      throw new Error('casUrl and serviceUrl are required');
    }

    this.casUrl = casUrl.replace(/\/+$/, '');
    this.serviceUrl = serviceUrl;
    this.language = language !== null && language !== void 0 ? language : 'ql';
    this.enableFlagHandling = enableFlagHandling;
    this.enableRecaptcha = enableRecaptcha;
  }

  _createClass(CasClient, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, serviceUrl) {
        var endpoint, response, responseData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = this.getEndpoint(_Object$assign({
                  path: 'login',
                  serviceUrl: serviceUrl || this.serviceUrl
                }, params));
                _context.next = 3;
                return fetch(endpoint, this.createGetOptions());

              case 3:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 6;
                  break;
                }

                throw new HTTPError(response);

              case 6:
                _context.next = 8;
                return response.json();

              case 8:
                responseData = _context.sent;
                return _context.abrupt("return", responseData.success ? responseData : _Promise.reject());

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getFormDefaults",
    value: function () {
      var _getFormDefaults = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        var endpoint, response, responseData, _responseData$form_de, executionKey, lt, _eventId;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = this.getEndpoint(_Object$assign({
                  path: 'login',
                  serviceUrl: this.serviceUrl
                }, params), true);
                _context2.next = 3;
                return fetch(endpoint, this.createGetOptions());

              case 3:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", _Promise.reject());

              case 6:
                _context2.next = 8;
                return response.json();

              case 8:
                responseData = _context2.sent;

                if (!(responseData && responseData.form_defaults)) {
                  _context2.next = 15;
                  break;
                }

                _responseData$form_de = responseData.form_defaults, executionKey = _responseData$form_de.executionKey, lt = _responseData$form_de.lt, _eventId = _responseData$form_de._eventId;
                this.executionKey = executionKey;
                this.loginTicket = lt;
                this.eventId = _eventId;
                return _context2.abrupt("return", responseData);

              case 15:
                if (!(responseData && responseData.success)) {
                  _context2.next = 17;
                  break;
                }

                return _context2.abrupt("return", _Promise.reject(responseData));

              case 17:
                return _context2.abrupt("return", _Promise.reject());

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getFormDefaults(_x3) {
        return _getFormDefaults.apply(this, arguments);
      }

      return getFormDefaults;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
        var username, password, rememberMe, rememberUsername, custLogin, renew, token, endpoint, response, responseData;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                username = _ref2.username, password = _ref2.password, rememberMe = _ref2.rememberMe, rememberUsername = _ref2.rememberUsername, custLogin = _ref2.custLogin, renew = _ref2.renew, token = _ref2.token;
                endpoint = this.getEndpoint({
                  path: 'login',
                  serviceUrl: this.serviceUrl,
                  custLogin: custLogin,
                  renew: renew
                }, true);
                _context3.next = 4;
                return fetch(endpoint, this.createPostOptions({
                  body: objectToQueryString(_Object$assign({
                    username: username,
                    password: password,
                    rememberMe: rememberMe,
                    rememberUsername: rememberUsername,
                    _rememberUsername: booleanToString(rememberUsername),
                    _rememberMe: booleanToString(rememberMe)
                  }, this.executionKey && {
                    execution: this.executionKey
                  }, this.loginTicket && {
                    lt: this.loginTicket
                  }, this.eventId && {
                    _eventId: this.eventId
                  })),
                  headers: _Object$assign({
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }, token && {
                    'X-Captcha-Token': token
                  })
                }));

              case 4:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context3.next = 9;
                return response.json();

              case 9:
                responseData = _context3.sent;
                return _context3.abrupt("return", responseData.success ? responseData : _Promise.reject(responseData));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function login(_x4) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "tokenLogin",
    value: function () {
      var _tokenLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref3) {
        var token, renew, endpoint, response, responseData;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                token = _ref3.token, renew = _ref3.renew;
                endpoint = this.getEndpoint({
                  path: 'tokenlogin',
                  renew: renew
                });
                _context4.next = 4;
                return fetch(endpoint, this.createPostOptions({
                  body: _JSON$stringify({
                    token: token
                  }),
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 4:
                response = _context4.sent;

                if (response.ok) {
                  _context4.next = 7;
                  break;
                }

                throw new HTTPError(response);

              case 7:
                _context4.next = 9;
                return response.json();

              case 9:
                responseData = _context4.sent;
                return _context4.abrupt("return", responseData.success ? responseData : _Promise.reject(responseData));

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function tokenLogin(_x5) {
        return _tokenLogin.apply(this, arguments);
      }

      return tokenLogin;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var endpoint, response, responseData;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                endpoint = this.getEndpoint({
                  path: 'logout'
                });
                _context5.next = 3;
                return fetch(endpoint, this.createGetOptions());

              case 3:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 6;
                  break;
                }

                throw new HTTPError(response);

              case 6:
                _context5.next = 8;
                return response.json();

              case 8:
                responseData = _context5.sent;
                return _context5.abrupt("return", responseData.logoutSuccess ? responseData : _Promise.reject());

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "imAlive",
    value: function () {
      var _imAlive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var endpoint, response, responseData, timeToKill, expiresAt;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                endpoint = this.getEndpoint({
                  path: 'imAlive'
                });
                _context6.next = 3;
                return fetch(endpoint, this.createGetOptions());

              case 3:
                response = _context6.sent;

                if (response.ok) {
                  _context6.next = 6;
                  break;
                }

                throw new HTTPError(response);

              case 6:
                _context6.prev = 6;
                _context6.next = 9;
                return response.json();

              case 9:
                responseData = _context6.sent;
                timeToKill = responseData.timeToKill, expiresAt = responseData.expiresAt;
                return _context6.abrupt("return", {
                  imAlive: response.ok,
                  timeToKill: timeToKill,
                  expiresAt: expiresAt
                });

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](6);
                return _context6.abrupt("return", {
                  imAlive: response.ok,
                  timeToKill: -1,
                  expiresAt: -1
                });

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[6, 14]]);
      }));

      function imAlive() {
        return _imAlive.apply(this, arguments);
      }

      return imAlive;
    }()
  }, {
    key: "mapFlagsToVersionSegment",
    value: function mapFlagsToVersionSegment() {
      if (this.enableRecaptcha) {
        return '/v3';
      }

      if (this.enableFlagHandling) {
        return '/v2';
      }

      return '';
    }
  }, {
    key: "getEndpoint",
    value: function getEndpoint(_ref4) {
      var path = _ref4.path,
          serviceUrl = _ref4.serviceUrl,
          custLogin = _ref4.custLogin,
          gateway = _ref4.gateway,
          renew = _ref4.renew;
      var useFeatureFlags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var versionSegment = useFeatureFlags ? this.mapFlagsToVersionSegment() : '';
      var params = [serviceUrl ? "service=".concat(encodeURIComponent(serviceUrl)) : null, gateway ? 'gateway=true' : null, custLogin ? 'cust_login=true' : null, renew ? 'renew=true' : null].filter(function (param) {
        return param !== null;
      }).join('&');
      var query = params ? "?".concat(params) : '';
      return "".concat(this.casUrl).concat(versionSegment, "/").concat(path).concat(query);
    }
  }, {
    key: "createGetOptions",
    value: function createGetOptions() {
      return {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Cache-Control': 'no-store'
        },
        credentials: 'include'
      };
    }
  }, {
    key: "createPostOptions",
    value: function createPostOptions(_ref5) {
      var body = _ref5.body,
          headers = _ref5.headers;
      return {
        method: 'POST',
        headers: _Object$assign({
          Accept: 'application/json',
          'Accept-Language': this.language,
          'Cache-Control': 'no-store'
        }, headers),
        body: body,
        credentials: 'include'
      };
    }
  }]);

  return CasClient;
}();
var instances = new _Map();
export var createCasClient = function createCasClient(config) {
  var instanceKey = "".concat(config.casUrl, ":").concat(config.serviceUrl, ":").concat(config.language);

  if (!instances.has(instanceKey)) {
    instances.set(instanceKey, new CasClient(config));
  }

  return instances.get(instanceKey);
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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